<mat-tab-group>
  <mat-tab label="My Profile">
    <user-component [user]="user"></user-component>
  </mat-tab>
  <mat-tab label="Change Password">
    <change-password-component></change-password-component>
  </mat-tab>
  <mat-tab label="MFA">
    <mfa-status></mfa-status>
  </mat-tab>
</mat-tab-group>
